import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import { isValidLoginStatus } from '@/shared/validation/login'
import { getPushSocketInstance } from '@/shared/socket'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'home',
  component: () => import('@/views/Home.vue')
},
{
  path: '/login',
  name: 'LoginView',
  component: () => import('@/views/LoginView.vue')
},
{
  path: '/setting',
  name: 'SettingView',
  component: () => import('@/views/SettingView.vue')
},
{
  path: '/notice',
  name: 'NoticeView',
  component: () => import('@/views/NoticeView.vue')
},
{
  path: '/bifurcation',
  name: 'Bifurcation',
  component: () => import('@/views/Bifurcation.vue')
},
{
  path: '/privacy',
  name: 'PrivacyView',
  component: () => import('@/views/PrivacyView.vue')
},
{
  path: '/phone',
  name: 'PhoneView',
  component: () => import('@/views/PhoneView.vue')
},
{
  path: '/email',
  name: 'Email',
  component: () => import('@/views/Email.vue')
},
{
  path: '/select-person',
  name: 'SelectPerson',
  component: () => import('@/views/SelectPerson.vue')
},
{
  path: '/menu',
  name: 'MenuView',
  props: true,
  component: () => import('@/views/MenuView.vue')
},
{
  path: '/confirm',
  name: 'ConfirmView',
  component: () => import('@/views/ConfirmView.vue')
},
{
  path: '/complete/:watingNum',
  name: 'CompleteView',
  props: true,
  component: () => import('@/views/CompleteView.vue')
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
let socketInstance = null
router.beforeEach((to, from, next) => {
  socketInstance = store.getters.getSocketInstance
  if (to.path === '/login') {
    console.debug('beforeEach login---', socketInstance)
    store.commit('removeSocketInstance')
    next()
  } else {
    // 로그인 페이지를 제외한 모든 페이지 진입시 storeIdx와 token검증 -> 검증 실패시 로그인 페이지로 이동
    if (isValidLoginStatus()) {
      // offline일때 home이 아니면 home로 이동
      if (store.getters.isOffline) {
        if (to.path === '/') {
          next()
        } else {
          router.push('/')
        }
      }
      if (socketInstance === null || socketInstance.id === 0) {
        // store에 socket 없을경우 socket 생성
        getPushSocketInstance()
      } else {
        if (socketInstance.disconnected) {
          socketInstance.connect()
        }
      }
      next()
    } else {
      alert('일시적 문제가 발생하여 로그아웃 되었습니다. 매장 직원을 불러주세요.')
      router.push('/login')
    }
  }
})

export default router
